
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.287 11.753l-.648.644a1.451 1.451 0 01-2.036 0 1.41 1.41 0 010-2.003L5.987 8.03c.494-.49 1.423-1.212 2.101-.54a.794.794 0 101.118-1.126c-1.15-1.142-2.853-.931-4.336.54L2.486 9.269a2.975 2.975 0 00-.886 2.126 2.976 2.976 0 00.886 2.127 3.023 3.023 0 002.136.876c.773 0 1.547-.292 2.135-.876l.649-.644a.79.79 0 00-.557-1.354.796.796 0 00-.562.229zm7.226-9.187c-1.238-1.228-2.967-1.294-4.111-.158l-.808.802a.793.793 0 101.117 1.124l.808-.8c.592-.59 1.369-.345 1.877.157a1.405 1.405 0 010 2.003L9.852 8.217c-1.163 1.153-1.709.613-1.942.381a.793.793 0 00-1.116 1.125c.534.53 1.144.792 1.782.792.782 0 1.608-.393 2.394-1.173l2.544-2.523a2.985 2.985 0 00.886-2.126 2.982 2.982 0 00-.887-2.127z"}})])
          )
        }
      }
    